export default "__VITE_ASSET__BRlq5JuN__"